import React from 'react';
import angularJs from '../../../assets/angularjs.png';

const AngularJs = () => (
  <section id="angularjs">
    <img data-src={angularJs} alt="AngularJS" />
    <h2>Angular JS</h2>
    <p>
      Créé en 2009 par <strong>Google</strong><br />
      Populaire parmi les développeurs<br />
      Outils nombreux et adaptés au travail en équipe<br />
      Idéal pour les solutions <em>Quick & Dirty</em><br />
      Mature pour le milieu professionnel<br />
      Paquets de base maintenus par <strong>Google</strong>
    </p>
  </section>
);

export default AngularJs;
